import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { ImageInterface } from 'common/types/entities/ImageInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createImage(
  parentId: string,
  masterBlockId?: MasterBlockId,
): ImageInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.Image, parentId, masterBlockId),
    alignSelf: 'center',
  }
}
